import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import moment from "moment";

import NoticeIcon from "../../../../Assets/Logo/NoticeIcon.svg";
import { useStyles } from "./DashboardNoticeCard.css";
import Axios from "axios";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { url } from "../../../../Config/Config";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";

class DashboardNoticeCard extends Component {
  constructor(props) {
    super(props);
    this.state = { notices: [] };
  }

  componentDidMount() {
    this.getNotices();
  }

  getNotices = async () => {
    try {
      const response = await Axios.get(`${url}/api/notices`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.notices.length !== 0) {
        this.setState({
          notices: response.data.notices,
          isEmpty: false,
        });
      } else {
        this.setState({
          notices: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getNotices();
      }
    }
  };

  render() {
    const { classes } = this.props;
    let filtered = this.state.notices.filter(
      (data) =>
        moment(data.createdAt).format("YYYY") ===
          moment(new Date()).format("YYYY") &&
        moment(data.createdAt).format("MM") === moment(new Date()).format("MM")
    );
    return (
      <Grid item xs={12} sm={12} md={4} xl={4} lg={4}>
        <Paper className={classes.root}>
          <div
            style={{ display: "flex", alignItems: "center", marginBottom: 10 }}
          >
            <img
              src={NoticeIcon}
              alt="Notice"
              style={{ width: 30, height: 30 }}
            />
            <div style={{ marginLeft: 10, fontSize: 18, fontWeight: "bold" }}>
              Recent Notices
            </div>
          </div>
          <Divider />
          <div className={classes.body}>
            {filtered.length !== 0 ? (
              filtered.map((notice, index) => (
                <ListItem divider key={index}>
                  {notice.title}
                </ListItem>
              ))
            ) : (
              <div>There is not any notice recently published</div>
            )}
          </div>
        </Paper>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(DashboardNoticeCard)));
